import axios from 'axios';
import { API_BASE_URL as BASE } from './apiConfig';

export interface TrialGenerateResponse {
  success: boolean;
  altText?: string;
  guestToken?: string;
  errorCode?: string;
  message?: string;
}

export interface TrialIndustryOption {
  itemKey: string;
  itemLabel: string;
}

const apiClient = axios.create({
  baseURL: `${BASE}/api/trial`,
  withCredentials: true, // trial_guest_token 쿠키 송수신용 (UX 보조 목적, 방어 수단 아님)
});

export const trialApi = {
  getIndustries: async (): Promise<TrialIndustryOption[]> => {
    const response = await apiClient.get('/industries');
    return (response.data || []).map((item: any) => ({
      itemKey: item.itemKey,
      itemLabel: item.itemLabel,
    }));
  },
  generateFromUpload: async (file: File, industryCode?: string, customInstruction?: string, turnstileToken?: string, outputLanguage?: string): Promise<TrialGenerateResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    if (industryCode) formData.append('industryCode', industryCode);
    if (customInstruction) formData.append('customInstruction', customInstruction);
    if (turnstileToken) formData.append('turnstileToken', turnstileToken);
    if (outputLanguage) formData.append('outputLanguage', outputLanguage);
    const response = await apiClient.post('/generate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  generateFromUrl: async (imageUrl: string, industryCode?: string, customInstruction?: string, turnstileToken?: string, outputLanguage?: string): Promise<TrialGenerateResponse> => {
    const formData = new FormData();
    formData.append('imageUrl', imageUrl);
    if (industryCode) formData.append('industryCode', industryCode);
    if (customInstruction) formData.append('customInstruction', customInstruction);
    if (turnstileToken) formData.append('turnstileToken', turnstileToken);
    if (outputLanguage) formData.append('outputLanguage', outputLanguage);
    const response = await apiClient.post('/generate', formData);
    return response.data;
  },
};
